import store from '../../../../common/store'
import { initNavigation, activateRoute } from '../../../../common/reducers/navigationSlice'
import NavigationStore from '../stores/NavigationStore'

const NavigationActions = {
  /** Initialise the nav tree from raw menu.json items. */
  initWithRawItems(rawItems) {
    NavigationStore.onInitWithRawItems(rawItems)
    store.dispatch(initNavigation(rawItems))
  },

  /** Mark a MenuItem as active and push its route into Redux state. */
  activate(item) {
    NavigationStore.onActivate(item)
    if (item.route) {
      store.dispatch(activateRoute(item.route))
    }
  },

  // Legacy stubs — not used at runtime but kept to avoid import errors in
  // files that destructure these before Phase 6 cleans them up.
  getItems: { listen: () => () => {} },
  fromMap() {},
}

export default NavigationActions
